import { PureComponent } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import PropTypes from 'prop-types';
import cns from 'classnames';
import cn from './styles.local.less';

export { default as selector } from './selectors';

export default class Footer extends PureComponent {
  static propTypes = {
    columns: PropTypes.array,
    copyright: PropTypes.string,
    countries: PropTypes.array,
    rate: PropTypes.string,
    ssl: PropTypes.string,
  };

  static defaultProps = {
    columns: [],
    copyright: '',
    countries: [],
    rate: '',
    ssl: '',
  };

  render() {
    const { columns, copyright, countries, rate, ssl } = this.props;

    const copyrightColumns = !(ssl && rate) ? 12 : 4;

    return (
      <footer className={cn.root}>
        <div className={cns(cn.container, 'container-xs')}>
          {countries.length && (
            <div className={cns(cn.section, cn.flags)}>
              <h5 className={cn.title}>{__('footer.countries')}</h5>
              <ul className="list-inline">
                {countries.map(({ link, iconName, title }) => {
                  return (
                    <li key={link}>
                      <span
                        className={cns(cn.flagIcon, iconName)}
                        title={title}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {columns.length ? (
            <Row className={cn.section}>
              {columns.map(({ items, title }) => (
                <Col key={title} md={4} sm={4}>
                  <h5 className={cn.title}>{title}</h5>
                  <ul className={cn.linkList}>
                    {items.map(({ link, name }) => (
                      <li key={name}>
                        <a href={link}>{name}</a>
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
            </Row>
          ) : null}

          <Row>
            {rate && (
              <Col
                className={cn.rate}
                dangerouslySetInnerHTML={{ __html: rate }}
                md={4}
              />
            )}

            {ssl && (
              <Col className={cn.ssl} md={4}>
                {ssl}
              </Col>
            )}

            {copyright && (
              <Col className={cn.copyright} md={copyrightColumns}>
                {copyright}
              </Col>
            )}
          </Row>
        </div>
      </footer>
    );
  }
}
